import React, { Component, Fragment } from 'react';
import axios from 'axios'
import { connect } from 'react-redux';
import { fetchUserFeedback } from "../../../../redux/actions/management_actions";
import FormColumn from '../../../Templates/FormColumn'
import { SORT, toggleSorting } from '../../../Templates/functions'
import CircularProgress from '@material-ui/core/CircularProgress';
class FeedbackTab extends Component {
  signal = axios.CancelToken.source()

  state = {
    sortingByTitle: 2,
    sortingByComment: 0,
    isLoading: true 
  }

  componentDidMount = () => {
    this.loadData()
  }

  componentWillUnmount = () => {
    this.signal.cancel('Api is being canceled');
  }


  loadData = () => {
    let signalToken = this.signal.token
    Promise.all([
      this.props.fetchUserFeedback(this.props.username, signalToken)
    ]).then(([res1]) => {
      this.setState({
        isLoading: false
      })
    }).catch(err => {
      if (axios.isCancel(err)) {
        console.info('User Profile Profile Tab - ', err.message)
      } else {
        console.debug('Error', err.message)
      }
    });
  };

  render() {
    let feedback = this.props.feedback || []

    if (this.state.sortingByTitle) {
      feedback = SORT(this.state.sortingByTitle, feedback, "wip_name")
    }
    if (this.state.sortingByComment) {
      feedback = SORT(this.state.sortingByComment, feedback, "comment")
    }

    let titles = []
    let comments = []

    feedback.forEach(f => {
      titles.push(f.wip_name)
      comments.push(f.comment)
    })

    return <div id="management-user-feedback" className="flex">
      {this.state.isLoading ?
        <Fragment>
          <CircularProgress />
        </Fragment>
        :
        <Fragment>
          <FormColumn title={"Title"} sort={() => toggleSorting(this.state.sortingByTitle, (value) => this.setState({ sortingByTitle: value, sortingByComment: 0 }))} sorting={this.state.sortingByTitle} content={titles} contentType={"text"} columnWidth={"30%"} />
          <FormColumn title={"Comment"} content={comments} nullSort={true} contentType={"text"} columnWidth={"70%"} />

          {/* <FormColumn title={"Comment"} sort={() => toggleSorting(this.state.sortingByComment, (value) => this.setState({ sortingByTitle: 0, sortingByComment: value }))} sorting={this.state.sortingByComment} content={comments} contentType={"text"} columnWidth={"70%"} /> */}
        </Fragment>}
  </div>
  }
}

//redux

const mSTP = (state) => {
  return ({
    feedback: state.management.user.feedback
  });
};

const mDTP = (dispatch) => {
  return ({
    fetchUserFeedback: (username, cancelToken) => dispatch(fetchUserFeedback(username, cancelToken))
  })
};

export default connect(mSTP, mDTP)(FeedbackTab);
